// Aeromist misting / outdoor cooling job photos.
// Shared between /outdoor-cooling-misting and the /projects gallery.
import deckFogging from "@/assets/cooling/deck-fogging-landscape.jpg.asset.json";
import fanProduct from "@/assets/cooling/aeromist-misting-fan-product.jpg.asset.json";
import poolFogging from "@/assets/cooling/pool-fogging-system.jpg.asset.json";
import playgroundFog from "@/assets/cooling/playground-fog-cooling.jpg.asset.json";
import industrialFans from "@/assets/cooling/industrial-misting-fans-brewery.jpg.asset.json";
import commercialPergola from "@/assets/cooling/commercial-pergola-misting.jpg.asset.json";
import portableStand from "@/assets/cooling/portable-misting-stand-dog.jpg.asset.json";
import dogCoolShot from "@/assets/cooling/dog-cool-shot-misting-nozzle.jpg.asset.json";
import poolsidePatio from "@/assets/cooling/poolside-patio-high-pressure-misting-san-antonio.jpg.asset.json";
import stoneColumnPatio from "@/assets/cooling/patio-misting-system-stone-columns-new-braunfels.jpg.asset.json";
import hotTubMistLine from "@/assets/cooling/patio-misting-line-hot-tub-hill-country-boerne.jpg.asset.json";
import beamFan from "@/assets/cooling/beam-mounted-misting-fan.jpg.asset.json";

export type MistingPhoto = {
  src: string;
  alt: string;
  label: string;
  caption: string;
  category: "High-Pressure Misting" | "Misting Fans" | "Fogging & Effects" | "Portable Cooling";
};

export const MISTING_PHOTOS: readonly MistingPhoto[] = [
  {
    src: commercialPergola.url,
    alt: "High-pressure misting nozzles cooling a stone and timber pergola patio overlooking a golf course",
    label: "Commercial Patio Misting",
    caption: "Commercial patio: stainless mist line run along the pergola rafters so guests stay cool without getting wet.",
    category: "High-Pressure Misting",
  },
  {
    src: industrialFans.url,
    alt: "Row of large industrial misting fans hanging from a metal awning over a brewery patio in Texas",
    label: "Industrial Misting Fans",
    caption: "Brewery pavilion: overhead industrial misting fans push cooled air the full length of a metal awning.",
    category: "Misting Fans",
  },
  {
    src: fanProduct.url,
    alt: "Black Aeromist high-pressure oscillating misting fan head on a pedestal stand",
    label: "Aeromist Fan Head",
    caption: "Aeromist high-pressure fan head — sealed motor, stainless nozzle ring, built for Texas humidity.",
    category: "Misting Fans",
  },
  {
    src: poolFogging.url,
    alt: "Poolside fogging system filling a rock waterfall and palm landscape with cool mist",
    label: "Poolside Fogging",
    caption: "Poolside fogging: low nozzles along the rock ledge drop deck temperatures on triple-digit afternoons.",
    category: "Fogging & Effects",
  },
  {
    src: playgroundFog.url,
    alt: "Backyard playground surrounded by a wall of cooling fog from an outdoor misting system",
    label: "Playground Cooling Fog",
    caption: "Play area: a fog curtain rings the structure so kids can stay outside through the hottest part of the day.",
    category: "Fogging & Effects",
  },
  {
    src: deckFogging.url,
    alt: "Landscape fogging nozzles releasing mist across a stone deck edge and boulder feature",
    label: "Landscape Fogging",
    caption: "Landscape fogging: hidden nozzles in the rock border add a cool, misted edge along the deck.",
    category: "Fogging & Effects",
  },
  {
    src: portableStand.url,
    alt: "Portable misting stand on a lawn with a golden retriever resting in the cooled mist",
    label: "Portable Misting Stand",
    caption: "Portable misting stand — hose-fed, moves anywhere in the yard, kennel, or wash rack.",
    category: "Portable Cooling",
  },
  {
    src: dogCoolShot.url,
    alt: "Handheld misting nozzle spraying a fine cooling mist toward a dog sitting on grass",
    label: "Handheld Cool Shot",
    caption: "Handheld cool-shot nozzle for dogs, livestock, and crews working in the heat.",
    category: "Portable Cooling",
  },
  {
    src: poolsidePatio.url,
    alt: "High-pressure patio misting system cooling a covered poolside patio and outdoor kitchen in San Antonio, Texas",
    label: "Poolside Patio Misting — San Antonio",
    caption: "San Antonio poolside patio: high-pressure mist line run along the covered patio beam, cooling the outdoor kitchen and pool deck.",
    category: "High-Pressure Misting",
  },
  {
    src: stoneColumnPatio.url,
    alt: "Residential covered patio misting system between stone columns on a New Braunfels, Texas home",
    label: "Covered Patio Misting — New Braunfels",
    caption: "New Braunfels back patio: mist line tucked under the roof edge between stone columns — cool air across the whole porch, no wet furniture.",
    category: "High-Pressure Misting",
  },
  {
    src: hotTubMistLine.url,
    alt: "Hill Country patio misting line spraying over a hot tub and pool courtyard near Boerne, Texas",
    label: "Hot Tub & Courtyard Misting — Boerne",
    caption: "Hill Country courtyard near Boerne: nozzles spaced along the portal beam to mist the hot tub, bar, and seating area at once.",
    category: "High-Pressure Misting",
  },
  {
    src: beamFan.url,
    alt: "Ceiling-mounted misting fan cooling a covered outdoor dining patio in Austin, Texas at dusk",
    label: "Ceiling-Mounted Misting Fan — Austin",
    caption: "Austin outdoor dining patio: beam-mounted misting fan aimed down the table run for evening service.",
    category: "Misting Fans",
  },
];
